import { Messages } from '../../../codegen/Localize';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const mixedContentOptions: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated
};
